import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setShowNavbar, setShowFriends } from "../stores/uiState/UiStateSlice";

function TermsOfService() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowNavbar(true));
    dispatch(setShowFriends(false));
  }, []);

  return (
    <section className="LegalPage">
      <div className="legalContainer">
        <h1 className="legalTitle">Terms of Service</h1>
        <p className="legalDate">Last updated: March 28, 2026</p>

        <div className="legalContent">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using Drafter at drafter.one (the
            &quot;Service&quot;), you agree to be bound by these Terms of
            Service. If you do not agree to these terms, please do not use the
            Service.
          </p>

          <h2>2. Description of Service</h2>
          <p>
            Drafter is an online game where users simulate League of Legends
            champion drafts and compete against other players. Our AI-powered
            algorithm, DrafterEye, analyzes champion interactions to determine
            win probabilities. The Service includes game modes, a competitive
            ranking system, player profiles, and analytical tools.
          </p>

          <h2>3. User Accounts</h2>
          <p>
            To access certain features, you must sign in with a Google account.
            You are responsible for maintaining the security of your account.
            You agree not to share your account credentials or allow others to
            access your account.
          </p>

          <h2>4. User Conduct</h2>
          <p>When using the Service, you agree not to:</p>
          <ul>
            <li>Use the Service for any unlawful purpose</li>
            <li>
              Attempt to manipulate rankings, exploit bugs, or gain unfair
              advantages
            </li>
            <li>Harass, abuse, or harm other users</li>
            <li>
              Use automated tools, bots, or scripts to interact with the Service
            </li>
            <li>Interfere with or disrupt the Service or its infrastructure</li>
            <li>Impersonate another user or entity</li>
          </ul>

          <h2>5. Intellectual Property</h2>
          <p>
            The Service, including its design, code, and original content, is
            owned by Drafter. League of Legends, champion names, and related
            imagery are trademarks of Riot Games, Inc. Our use of League of
            Legends content is in accordance with Riot Games&apos; policies.
          </p>

          <h2>6. Free and Premium Services</h2>
          <p>
            The basic game is free to play. Certain features, such as unlimited
            draft analyses, may require a paid subscription. Free users are
            limited to a set number of analyses per day. We reserve the right to
            modify pricing and feature availability at any time.
          </p>

          <h2>7. Advertisements</h2>
          <p>
            The Service displays advertisements through Google AdSense. By using
            the Service, you acknowledge that ads are part of the experience and
            agree not to use ad-blocking tools that may interfere with the
            Service.
          </p>

          <h2>8. Disclaimer of Warranties</h2>
          <p>
            The Service is provided &quot;as is&quot; without warranties of any
            kind. We do not guarantee that the Service will be uninterrupted,
            error-free, or that win probability predictions will be accurate.
            Our algorithm provides statistical estimates based on historical
            data and should not be considered definitive predictions.
          </p>

          <h2>9. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Drafter shall not be liable
            for any indirect, incidental, special, or consequential damages
            arising from your use of the Service, including but not limited to
            loss of data, loss of profits, or any decisions made based on the
            Service&apos;s analysis.
          </p>

          <h2>10. Account Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account at any
            time for violations of these Terms, abusive behavior, or any reason
            we deem necessary. You may also delete your account by contacting
            us.
          </p>

          <h2>11. Modifications</h2>
          <p>
            We may modify these Terms at any time. Continued use of the Service
            after changes constitutes acceptance of the updated Terms. We will
            update the &quot;Last updated&quot; date when changes are made.
          </p>

          <h2>12. Governing Law</h2>
          <p>
            These Terms are governed by the laws of France. Any disputes arising
            from these Terms shall be subject to the exclusive jurisdiction of
            the courts of Paris, France.
          </p>

          <h2>13. Contact</h2>
          <p>
            For questions about these Terms, please contact us at:{" "}
            <a href="mailto:contact@drafter.one">contact@drafter.one</a>
          </p>
        </div>
      </div>
    </section>
  );
}

export default TermsOfService;
